import { useId } from 'react';
import S from './TextAreaStyles';

type Props = {
  label?: string;
  tooltip?: string;
  name: string;
  placeholder?: string;
  onChange: any;
  onBlur?: any;
  onKeyDown?: any,
  value?: string;
  error?: string | boolean;
  styleWrapper?: Record<string, string>;
  maxLength?: number;
  disabled?: boolean;
  rows?: number;
  cols?: number;
};

function TextArea({
  label,
  tooltip,
  name,
  placeholder,
  onChange,
  onBlur,
  onKeyDown,
  value,
  error,
  styleWrapper,
  maxLength,
  disabled,
  rows,
  cols,
}: Props): JSX.Element {
  const id = useId();
  return (
    <S.Wrapper
      error={!!error}
      style={styleWrapper}
    >
      {!!label && (
        <label htmlFor={id}> {label} </label>
      )}
      <textarea
        id={id}
        name={name}
        placeholder={placeholder || label}
        title={tooltip}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        value={value}
        maxLength={maxLength}
        disabled={disabled}
        autoComplete="off"
        rows={rows}
        cols={cols}
      />
      {!!error && (
        <S.ErrorMessage> {error} </S.ErrorMessage>
      )}
    </S.Wrapper>
  );
}

export default TextArea;
